import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStrikethrough = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M16 4H9a3 3 0 0 0-2.83 4" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 12a4 4 0 0 1 0 8H6" }),
		/* @__PURE__ */ _jsx("line", {
			x1: 4,
			x2: 20,
			y1: 12,
			y2: 12
		})
	]
});
const ForwardRef = forwardRef(SvgStrikethrough);
export default ForwardRef;
